/**
 * 判断是否是手机号
 * @param num
 * @return {*}
 */
export function isPhoneNo(num) {
  let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0135678]|18[0-9]|19[0267]14[579])[0-9]{8}$/;
  let r = num.match(reg);
  if (r !== null) return num;
  return null;
}

/**
 * 去掉字符串全部空格
 * @param string
 * @return {*}
 */
export function trimString(string) {
  return string.replace(/\s*/g, '');
}